<template>
  <div>
    <v-text-field v-model="search" prepend-inner-icon="search" clearable label="Buscar" />
    <v-treeview
        v-model="tree"
        :active.sync="active"
        activatable
        :items="exams"
        :search="search"
        :filter="filter"
        :open.sync="open"
        class="text-left"
        multiple-active
        open-on-click
        return-object
        hover
    >
      <template v-slot:prepend="{ item, open }">

        <v-icon
            v-if="item.children && item.children.length > 0"
            :color="(open ? 'primary' : 'secondary')"
        >{{ open ? 'mdi-folder-open' : 'mdi-folder' }}
        </v-icon>

        <v-icon
            v-else
            :color="active.find(exam => exam.id === item.id) ? 'primary' : 'grey'">
          fas fa-file-alt
        </v-icon>

      </template>

      <template v-slot:append="{item, open}">

          <v-icon
              v-if="!item.children || item.children.length === 0"
              :color="active.find(exam => exam.id === item.id) ? 'primary' : 'secondary'">
            {{active.find(exam => exam.id === item.id) ? 'far fa-check-circle' : 'far fa-circle'}}
          </v-icon>

      </template>
    </v-treeview>
  </div>
</template>

<script>
export default {
  name: "PhysicalExamsTree",
  props:{
    caseSensitive:{
      type: Boolean,
      default: false
    },
    exams: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  data(){
    return {
      firstLoad: true,
      tree: [],
      active: [],
      open: [],
      search: null,
    }
  },
  mounted(){
    const vm = this

    //vm.setActives()
  },
  computed:{
    filter(){
      return this.caseSensitive
          ? (item, search, textKey) => item[textKey].indexOf(search) > -1
          : undefined
    }
  },
  methods:{
    setActives(){
      const vm = this
      if(vm.selected.length > 0){
        vm.active = vm.selected
      }
      vm.$nextTick(function(){
        vm.firstLoad = false
      })

    },
    iterate(children = [], callback){

      const vm = this
      let ids = []

      for(let i in children){

        if(children[i].children){
          ids = [
            ...ids,
            ...vm.iterate(children[i].children)
          ]
          continue
        }

        const item = children[i]

        ids.push(item)

      }

      return ids

    }
  },
  watch:{
    selected(){
      const vm = this
      vm.setActives()
    },
    active(val){
      if(this.firstLoad) return
      this.$emit('change', val)
    }
  }
}
</script>

<style scoped>

</style>
